/**
 * Wrapper for local storage that prefixes all keys with the name of the store
 * to prevent overlapping storage keys on the same domain.
 */
class Storage {
    constructor(name) {
        this.name = name;
    }
    setItem(key, value) {
        localStorage.setItem(`${this.name}-${key}`, value);
    }
    getItem(key) {
        return localStorage.getItem(`${this.name}-${key}`);
    }
}

export default new Storage(process.env.REACT_APP_URL_PATH);